module.exports = __webpack_public_path__ + "static/media/coding.013663a9.png";